const SelectCatagory = ({ select }) => {
    return (
        <select defaultValue={select}>
            <option value="all">All Categories</option>

            {/* Art Categories */}
            <option value="drawing">Drawing</option>
            <option value="sketching">Sketching</option>
            <option value="painting">Painting</option>
            <option value="digital-art">Digital Art</option>
            <option value="illustration">Illustration</option>
            <option value="crafts">Crafts</option>
            <option value="calligraphy">Calligraphy</option>
            <option value="sculpture">Sculpture</option>
            <option value="art-tutorials">Art Tutorials</option>
            <option value="art-gallery">Art Gallery</option>
            <option value="photography">Photography</option>

            {/* Music Categories */}
            <option value="vocal">Vocal</option>
            <option value="instrumental">Instrumental</option>
            <option value="guitar">Guitar</option>
            <option value="piano">Piano</option>
            <option value="violin">Violin</option>
            <option value="flute">Flute</option>
            <option value="drums">Drums</option>
            <option value="music-theory">Music Theory</option>
            <option value="music-production">Music Production</option>
            <option value="recording">Recording</option>
            <option value="band">Band</option>

            {/* Events / General */}
            <option value="art-events">Art Events</option>
            <option value="music-events">Music Events</option>
            <option value="workshops">Workshops</option>
            <option value="courses">Courses</option>
        </select>
    );
};

export default SelectCatagory;
